export default "__VITE_ASSET__DB2A8pKG__"